import i18n from "../i18n";
import { moduleSettings } from "../stores/module-settings.store";
import { selectionStore } from "../stores/selection.store";
import { DropdownOption, GuestsCapacity } from "../types";
import { requestParamsImpl } from "./request-params.service";

class SelectionGuestsService {
  static service: SelectionGuestsService | undefined;
  private _guestsCapacity: GuestsCapacity | undefined;
  static get(): SelectionGuestsService {
    if (!this.service) {
      this.service = new SelectionGuestsService();
    }
    return this.service!;
  }

  get guestsCapacity(): GuestsCapacity {
    return (
      this._guestsCapacity ||
      (this._guestsCapacity = moduleSettings.getCapacity())
    );
  }

  setDefaultSelectedGuest() {
    const _isUpdateFromBooking = moduleSettings.isUpdateFromBooking;
    if (!moduleSettings.selectOnlyPaxFirst || _isUpdateFromBooking) {
      const overwrittenPax = requestParamsImpl.overwrittenPax();
      if (overwrittenPax) {
        selectionStore.guests = overwrittenPax;
      } else {
        const booked_persons_number =
          (_isUpdateFromBooking &&
            moduleSettings.settings.update_from_booking
              .booked_persons_number) ||
          0;
        const children_number =
          (moduleSettings.isUpdateFromBooking &&
            moduleSettings.settings.update_from_booking?.children_number) ||
          0;
        selectionStore.children = children_number > 0 ? children_number : 0;
        selectionStore.guests =
          booked_persons_number > 0
            ? booked_persons_number - selectionStore.children
            : moduleSettings.defaultPersons || this.guestsCapacity.minGuests;
      }
    }
  }

  setDefaultSelectedGuestWhenChildren() {
    if (selectionStore.children > 0 && selectionStore.guests == 0) {
      selectionStore.guests = 1;
    }
  }

  guestsDropdownOption(): Array<DropdownOption> {
    const childrenManagementEnabled = moduleSettings.childrenManagementEnabled;
    let options: Array<DropdownOption> = [];
    for (
      let i = childrenManagementEnabled ? 1 : this.guestsCapacity.minGuests;
      i <= this.guestsCapacity.maxGuests;
      i++
    ) {
      options.push({
        value: `${i}`,
        displayText: `${i}`,
        isSelected: i === selectionStore.guests,
      });
    }
    return options;
  }

  maxChildrenAge(): string {
    return (
      "(< " +
      moduleSettings.childrenMaxAge +
      " " +
      i18n.t("instabook.common.years") +
      ")"
    );
  }

  setTypeOfGuestToPlaceholder(type: string): string {
    switch (type) {
      case "adults":
        return i18n.t("instabook.bookings.adults");
      case "children":
        return i18n.t("instabook.bookings.children", {
          max_children_age: this.maxChildrenAge(),
        });
      default:
        return i18n.t("instabook.bookings.persons");
    }
  }

  setSelectedGuestsToString(
    selectedGuests: number,
    type: string = "persons"
  ): string {
    switch (selectedGuests) {
      case 0:
        return "";
      default:
        return (
          selectedGuests +
          " " +
          this.setTypeOfGuestsToString(selectedGuests, type)
        );
    }
  }

  setTypeOfGuestsToString(selectedGuests: number, type: string): string {
    switch (type) {
      case "adults":
        return selectedGuests > 1
          ? i18n.t("instabook.common.adults")
          : i18n.t("instabook.common.adult");
      case "children":
        const _typeOfGuests =
          selectedGuests > 1
            ? i18n.t("instabook.common.children")
            : i18n.t("instabook.common.child");
        return _typeOfGuests + " " + this.maxChildrenAge();
      default:
        return selectedGuests > 1
          ? i18n.t("instabook.common.people")
          : i18n.t("instabook.common.person");
    }
  }
}

export default SelectionGuestsService.get();
